import React from 'react'
import { Box, P } from '@allied-solutions/affinity'

export const LoanInformationRow = ({ label, children }) => {
  return (
    <Box 
      display="flex" 
      justifyContent="space-between" 
      borderBottom={"1px solid"} 
      borderColor="border.defaultLight" 
      py="2xl" 
      className="loan-information-box-item"
    >
      <P typeStyle="labelLarge.medium" mb="0">{label}</P>
      <Box textAlign="right">
        {children}
      </Box>
    </Box>
  )
}

